import filter from "lodash/filter";
import {
  GetUsersDocument,
  GetUsersQuery,
  MethodType,
  QueryGetUsersArgs,
  UserType,
  useWatchUsersSubscription,
} from "~@/graphql/codegen/generated";
import useExitApp from "~@/hooks/useExitApp";
import useInternalUser from "~@/hooks/useInternalUser";

// Хук для отслеживания изменений в пользователях
const useWatchUsers = () => {
  const { internalUser } = useInternalUser(); // Получаем текущего внутреннего пользователя

  const exitApp = useExitApp(); // Хук для выхода из приложения

  // Подписка на изменения пользователей
  useWatchUsersSubscription({
    async onData({ data: { data: watchUsersData }, client: { cache } }) {
      const watchUsers = watchUsersData?.watchUsers; // Данные о пользователях, полученные из подписки

      if (watchUsers) {
        const { user: watchUser, method } = watchUsers as Required<
          typeof watchUsers
        >;

        switch (method) {
          case MethodType.Delete: {
            // Обработка удаления пользователя
            if (internalUser?.id === watchUser?.id) {
              exitApp();
            } else {
              cache.updateQuery<GetUsersQuery, QueryGetUsersArgs>(
                {
                  query: GetUsersDocument,
                  variables: {
                    input: {
                      type: UserType.Internal,
                      isActive: true,
                    },
                  },
                },
                (data) => {
                  if (data?.getUsers) {
                    return {
                      getUsers: {
                        ...data.getUsers,
                        users: filter(
                          data.getUsers.users,
                          (user) => user?.id !== watchUser?.id
                        ),
                        pagination: {
                          ...data.getUsers.pagination,
                          totalItems:
                            (data.getUsers.pagination?.totalItems || 1) - 1,
                        },
                      },
                    };
                  }

                  return data;
                }
              );

              cache.updateQuery<GetUsersQuery, QueryGetUsersArgs>(
                {
                  query: GetUsersDocument,
                  variables: {
                    input: {
                      type: UserType.Internal,
                      isActive: false,
                    },
                  },
                },
                (data) => {
                  if (data?.getUsers) {
                    return {
                      getUsers: {
                        ...data.getUsers,
                        users: [watchUser, ...(data.getUsers.users || [])],
                        pagination: {
                          ...data.getUsers.pagination,
                          totalItems:
                            (data.getUsers.pagination?.totalItems || 0) + 1,
                        },
                      },
                    };
                  }

                  return data;
                }
              );
            }

            break;
          }
          case MethodType.Restore: {
            // Обработка восстановления пользователя

            cache.updateQuery<GetUsersQuery, QueryGetUsersArgs>(
              {
                query: GetUsersDocument,
                variables: {
                  input: {
                    type: UserType.Internal,
                    isActive: false,
                  },
                },
              },
              (data) => {
                if (data?.getUsers) {
                  return {
                    getUsers: {
                      ...data.getUsers,
                      users: filter(
                        data.getUsers.users,
                        (user) => user?.id !== watchUser?.id
                      ),
                      pagination: {
                        ...data.getUsers.pagination,
                        totalItems:
                          (data.getUsers.pagination?.totalItems || 1) - 1,
                      },
                    },
                  };
                }

                return data;
              }
            );

            cache.updateQuery<GetUsersQuery, QueryGetUsersArgs>(
              {
                query: GetUsersDocument,
                variables: {
                  input: {
                    type: UserType.Internal,
                    isActive: true,
                  },
                },
              },
              (data) => {
                if (data?.getUsers) {
                  return {
                    getUsers: {
                      ...data.getUsers,
                      users: [watchUser, ...(data.getUsers.users || [])],
                      pagination: {
                        ...data.getUsers.pagination,
                        totalItems:
                          (data.getUsers.pagination?.totalItems || 0) + 1,
                      },
                    },
                  };
                }

                return data;
              }
            );

            break;
          }
          default:
            break;
        }
      }
    },
  });
};

export default useWatchUsers;
